/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import Card from 'components/card/Card'
import { Checkbox, Form, Input, Typography } from 'antd'
import { IconSearch } from 'components/icons'
import TableParticipant from './TableParticipant'
import { ExtendedCampaignsProgram, ExtendedUser } from '../hooks/useCampaignCreation'
import { FormikErrors } from 'formik'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import dayjs from 'dayjs'

export interface IProps {
  detailCampaign: ExtendedCampaignsProgram
  participants: ExtendedUser[]
  onChange: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => Promise<void> | Promise<FormikErrors<ExtendedCampaignsProgram>>
}

const CampaignParticipant = ({ detailCampaign, participants, onChange }: IProps) => {
  const [search, setSearch] = useState('')
  const { startTime, endTime } = detailCampaign

  function generateObjects(months: string[]) {
    const result: any = []
    months.forEach(month => {
      const monthIndex = dayjs(month, 'MMMM').month()
      ;['DAILY', 'MONTHLY'].forEach(type => {
        result.push({
          startTime: dayjs().month(monthIndex).startOf('month').valueOf(),
          endTime: dayjs().month(monthIndex).endOf('month').valueOf(),
          targetFfbWeightTonne: 0,
          type: type,
        })
      })
    })
    return [
      ...result,
      {
        startTime: detailCampaign.startTime,
        endTime: detailCampaign.endTime,
        targetFfbWeightTonne: 0,
        type: 'QUARTERLY',
      },
    ]
  }

  const countDuration = (startTime: number, endTime: number) => {
    if (startTime == 0) {
      return []
    }
    const start = dayjs(startTime)
    const end = dayjs(endTime)
    const months = []

    let currentMonth = start
    while (currentMonth.isBefore(end) || currentMonth.isSame(end, 'month')) {
      months.push(currentMonth.format('MMMM'))
      currentMonth = currentMonth.add(1, 'month')
    }

    return months.length > 0 ? months : []
  }

  const handleSelectAll = (list: ExtendedUser[], e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked

    if (isChecked) {
      const idMap = new Map(list.map(obj => [obj.userId, true]))
      const missingParticipants = participants.filter(obj => !idMap.has(obj.userId))
      const formattedParticipants = missingParticipants.map(record => ({
        id: record.id,
        userId: record.userId,
        targets: generateObjects(countDuration(startTime, endTime)),
      }))
      const newArray = [...list, ...formattedParticipants]
      onChange('participantsExtend', newArray)
    } else {
      onChange('participantsExtend', [])
    }
  }

  return (
    <Card
      className="h-fit !p-0 mt-8"
      loading={false}
      dataTestId="card_participant"
      spinnerTestId="loader_participant"
    >
      <Card.Header className="py-6" border={false}>
        <Typography.Text className="px-8 border-l-4 border-y-0 border-r-0 border-solid border-primary-600 text-xl font-bold">
          2. Informasi Peserta
        </Typography.Text>
      </Card.Header>
      <Card.Body className="m-0 pb-8 px-8">
        <Form>
          <Input
            prefix={<IconSearch />}
            className="w-full"
            data-testid="input-search-name"
            placeholder="Cari nama"
            onChange={({ target: { value } }) => setSearch(value)}
          />
          <div className="flex flex-row justify-between">
            <div className="flex flex-col my-3">
              <Typography.Title className="text-sm">Daftar Peserta</Typography.Title>
              <Typography.Text className="text-gray-500">
                {detailCampaign.participantsExtend.length} Terpilih
              </Typography.Text>
            </div>
            <div className="items-center flex">
              <Checkbox
                data-testid="select-all"
                checked={detailCampaign.participantsExtend.length === participants.length}
                onChange={e => handleSelectAll(detailCampaign.participantsExtend, e)}
              >
                Pilih semua pengguna
              </Checkbox>
            </div>
          </div>
          <TableParticipant
            detailCampaign={detailCampaign}
            data={participants}
            search={search}
            handleParticipants={onChange}
            countDuration={countDuration}
            generateObjects={generateObjects}
          />
        </Form>
      </Card.Body>
    </Card>
  )
}

export default CampaignParticipant
